import { FilePresent, PictureAsPdf } from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import TableViewIcon from "@mui/icons-material/TableView";
import PhotoIcon from "@mui/icons-material/Photo";
import ArchiveIcon from "@mui/icons-material/Archive";
import React from "react";

interface IProps {
	fileName: string;
}

const FileIcon = (props: IProps) => {
	const ext = props.fileName.split(".").pop()?.toLowerCase();
	const extentions = [
		{
			icon: <PictureAsPdf />,
			exts: ["pdf"],
		},
		{
			icon: <DescriptionIcon />,
			exts: ["docx", "doc", "txt", "pages"],
		},
		{
			icon: <TableViewIcon />,
			exts: ["xlsx", "xls", "numbers"],
		},
		{
			icon: <PhotoIcon />,
			exts: ["jpg", "jpeg", "png", "gif", "bmp", "ico"],
		},
		{
			icon: <ArchiveIcon />,
			exts: ["zip", "rar", "7z", "tar", "gz"],
		},
	];

	if (ext) {
		for (let i = 0; i < extentions.length; i++) {
			if (extentions[i].exts.indexOf(ext) !== -1) {
				return extentions[i].icon;
			}
		}
	}

	return <FilePresent />;
};

export default FileIcon;
